import React, { useCallback } from 'react';
import { reportClick } from '@/utils/report';
import styles from '../index.less';

const IncomeSummary = ({ pageName, calClick, summaryData }) => {
  const renderYIncomeVal = useCallback(() => {
    // 是否计算中
    if (summaryData?.ic) {
      return <em>计算中...</em>;
    }
    // 同时有现金和云豆收益
    if (summaryData?.yic > 0 && summaryData?.yicb > 0) {
      return (
        <>
          <div>
            <em>+{summaryData.yic}</em>
            <span className={styles.valUnit}>元</span>
          </div>
          <em>+{summaryData.yicb}</em>
          <span className={styles.valUnit}>云豆</span>
        </>
      );
    }
    // 只有云豆收益
    if (summaryData?.yicb >= 0) {
      return (
        <>
          <em>
            {summaryData.yicb > 0 && '+'}
            {summaryData.yicb}
          </em>
          {summaryData.yicb > 0 && <span className={styles.valUnit}>云豆</span>}
        </>
      );
    }
    // 只有现金收益
    if (summaryData?.yic > 0) {
      return (
        <>
          <em>{summaryData.yic}</em>
          <span className={styles.valUnit}>元</span>
        </>
      );
    }
  }, [summaryData.ic, summaryData.yic, summaryData.yicb]);

  const handleCalClick = useCallback(() => {
    reportClick({
      page_name: pageName,
      button_name: 'group_cumulative_income',
    });
    calClick();
  }, [calClick, pageName]);

  return (
    <div className={styles.groupIncomeSummaryHead}>
      <div onClick={handleCalClick} className={`${styles.metric} ${styles.line}`}>
        <span className={styles.title}>总收益(元)</span>
        <p className={styles.amount}>{summaryData?.ti}</p>
      </div>
      <div className={styles.metric}>
        <span className={styles.title}>昨日收益</span>
        <p className={styles.amount}>{renderYIncomeVal()}</p>
      </div>
    </div>
  );
};
export default IncomeSummary;
